import './component.scss'
import $ from 'jquery'
import 'slick-carousel'
import 'Components/site/subsidy_experience_card/component'

const SLICK_TARGET_SELECTOR = '.js-slick-experience-target'
const DOT_LIMIT_COUNT = 5
const TABLET_WIDTH = 999

$(() => {
  const experienceCount = $('.js-slick-experience-target').data('experiences-count')
  const slickImagesOptions = {
    speed: 500,
    lazyLoad: 'progressive',
    infinite: true,
    dots: experienceCount <= DOT_LIMIT_COUNT,
    responsive: [{
      breakpoint: TABLET_WIDTH,
      settings: {
        dots: false
      }
    }]
  }

  $(SLICK_TARGET_SELECTOR).slick(slickImagesOptions)
})
